module.exports = __webpack_public_path__ + "img/modal-purchase-null.a72d3a15.svg";